import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";

import { RegMenReportsService } from "~/entity/RegMenReports/api/service";
import { IAvailableRegionalManager } from "~/entity/RegMenReports/model/schema";

const LIMIT = 25;

/** Опции селекта РМ из REST /user/available-regional-managers с поиском и догрузкой. */
export const useAvailableRegionalManagers = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [items, setItems] = useState<IAvailableRegionalManager[]>([]);

  const { data, isFetching } = useQuery(
    ["availableRegionalManagers", page, search],
    () =>
      RegMenReportsService.GET.getAvailableRegionalManagers({
        search: search || undefined,
        page,
        limit: LIMIT,
      }).then((response) => response.data),
    { keepPreviousData: true },
  );

  useEffect(() => {
    if (!data) return;
    setItems((prev) =>
      data.page === 1 ? data.items : [...prev, ...data.items],
    );
  }, [data]);

  const options = useMemo(
    () =>
      items.map((manager) => ({
        label: manager.roleName
          ? `${manager.fullname}, ${manager.roleName.replace(/^\*/, "")}`
          : manager.fullname,
        value: manager.id,
      })),
    [items],
  );

  const searchRegMen = useMemo(
    () =>
      debounce((searchText: string) => {
        setPage(1);
        setSearch(searchText);
      }, 300),
    [],
  );

  const onScrollBottomRegMen = () => {
    if (!isFetching && data && page < data.totalPages) {
      setPage((prev) => prev + 1);
    }
  };

  return { regMenOptions: options, onScrollBottomRegMen, searchRegMen };
};
